import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next';

const useFetchAttractionByURL = (city, slug, preview) => {
    const [attraction, setAttraction] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const { i18n } = useTranslation();


    const fetchAttractions = React.useCallback(async () => {
        setIsLoading(true)
        const { REACT_APP_BASE_URL } = process.env
        const token = localStorage.getItem('token');
        const params = {
            city,
            slug,
            lng: i18n.language
        }

        if (preview) {
            params.preview = true
        }

        try {
            const { data } = await axios.get(
                `${REACT_APP_BASE_URL}/index.php?r=api/attractions`,
                {
                    headers: {
                        'x-authorization-token': token
                    },
                    params: params
                }
            ) || {}

            setIsLoading(false)
            if (data.length) {
                setAttraction(data[0])
            }
        } catch (err) {
            console.error('Error fetching attraction data: ', err)
            setIsLoading(false)
        }
    }, [city, slug])

    React.useEffect(() => {
        fetchAttractions()
    }, [fetchAttractions])

    return {
        attraction,
        isLoading,
    }
}

export default useFetchAttractionByURL
